module.exports = __webpack_public_path__ + "img/collection-engagementRingsEntwined@2x.85f272c.jpg";